export default {
    $$default: {},
    memberType: {
        0: '总管理员',
        1: '管理员',
        2: '成员',
    },
    tradeType: {
        1: '分配',
        2: '充值',
        3: '订阅',
        4: '打赏',
        5: '退款',
        6: '会员卡',
        7: '课程',
        8: '专题',
    },
    enjoyType: {
        0: '个人',
        1: '团队',
        2: '机构',
    },
    incomeType: {
        1: '收入',
        2: '支出',
    },
    contentType: {
        0: '文章',
        1: '视频',
        2: '文档',
    },
    inColumn: {
        0: '否',
        1: '是'
    }
};
